const m04Section = {
  id: 'm04',
  name: '2027ScoresheetM04Sub1Label',
  fields: [
    {
        scoring: '2027ScoresheetM04Sub2Label',
        id: 'm04_scoring_1',
        options: [
          {
            description: '0',
            value: 0
          },
          {
            description: '1',
            value: 1
          },
          {
            description: '2',
            value: 2
          }  
          
        ]
      },
      {
        scoring: '2027ScoresheetM04Sub3Label',
        id: 'm04_scoring_2',
        options: [
          {
            description: 'noLabel',
            value: false
          },
          {
            description: 'yesLabel',
            value: true
          },
          
        ]
      },
      {
          scoring: '2027ScoresheetM04Sub4Label',
          id: 'm04_scoring_3',
          options: [
              {
                  description: 'noLabel',
                  value: false
              },
              {
                  description: 'yesLabel',
                  value: true
              },
          ]
      }
  ]
}

export default m04Section;